import * as orderActions from '../actions/order'
import {ApiRequestStates} from '../const'

import {reducer} from './helpers'

export const initialState = {
  allUserOrders: null,
  userOrdersRequestState: ApiRequestStates.IDLE,
}

export default reducer(initialState, (state, action) => {
  const {payload, type} = action

  switch (type) {
    case orderActions.GET_ALL_USER_ORDERS:
      return {
        allUserOrders: null,
        userOrdersRequestState: ApiRequestStates.IDLE,
      }
    case orderActions.GET_ALL_USER_ORDERS_FAILURE:
      return {
        userOrdersRequestState: ApiRequestStates.ERROR,
      }
    case orderActions.GET_ALL_USER_ORDERS_PENDING:
      return {
        userOrdersRequestState: ApiRequestStates.PENDING,
      }
    case orderActions.GET_ALL_USER_ORDERS_SUCCESS:
      return {
        allUserOrders: payload,
        userOrdersRequestState: ApiRequestStates.SUCCESS,
      }
    default:
      return null
  }
})
